import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export const Jcb = ({ size, className, id }) => {
  let ratio = size / 100;

  let width = size,
    height = 63 * ratio;

  let _attributes = {
    width: width || 100,
    height: height || 63,
    viewBox: "0 0 100 63"
  };

  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(className);
  }

  return (
    <svg {..._attributes}>
      <defs>
        <linearGradient id="jcbLinearGradient" x1="-0.749" y1="0.885" x2="1.828" y2="0.885" gradientUnits="objectBoundingBox">
          <stop offset="0" stop-color="#007940" />
          <stop offset="0.228" stop-color="#00873f" />
          <stop offset="0.743" stop-color="#40a737" />
          <stop offset="1" stop-color="#5cb531" />
        </linearGradient>
        <linearGradient id="jcbLinearGradient2" x1="-0.058" y1="0.541" x2="0.831" y2="0.541" href="#jcbLinearGradient"/>
      <linearGradient id="jcbLinearGradient3" x1="-0.818" y1="1.102" x2="1.995" y2="1.102" href="#jcbLinearGradient"/>
      <linearGradient id="jcbLinearGradient4" x1="0.191" y1="0.541" x2="1.094" y2="0.541" gradientUnits="objectBoundingBox">
          <stop offset="0" stop-color="#1f286f" />
          <stop offset="0.475" stop-color="#004e94" />
          <stop offset="0.826" stop-color="#0066b1" />
          <stop offset="1" stop-color="#006fbc" />
        </linearGradient>
        <linearGradient id="jcbLinearGradient5" x1="0.059" y1="0.54" x2="0.937" y2="0.54" gradientUnits="objectBoundingBox">
          <stop offset="0" stop-color="#6c2c2f" />
          <stop offset="0.174" stop-color="#882730" />
          <stop offset="0.573" stop-color="#be1833" />
          <stop offset="0.859" stop-color="#dc0436" />
          <stop offset="1" stop-color="#e60039" />
        </linearGradient>
      </defs>
      <g transform="translate(-1170.5 -560.5)">
        <rect width="100" height="63" transform="translate(1170.5 560.5)" fill="none" />
        <g transform="translate(1193.74 571.064)">
          <g transform="translate(0)">
            <path d="M71.979,46.638a8.246,8.246,0,0,1-8.234,8.234h-44.8V22.26a8.246,8.246,0,0,1,8.234-8.234h44.8Z" transform="translate(-18.944 -14.026)" fill="#fff" />
            <g transform="translate(35.529 2.755)">
              <path d="M234.976,135.9h3.4c.1,0,.324-.032.421-.032a1.519,1.519,0,0,0,1.2-1.524,1.573,1.573,0,0,0-1.2-1.524,1.713,1.713,0,0,0-.421-.032h-3.4Z" transform="translate(-232.059 -114.408)" fill="url(#jcbLinearGradient)" />
              <path d="M224.515,29.509a5.9,5.9,0,0,0-5.9,5.9v6.127h8.331a3.333,3.333,0,0,1,.584.032c1.88.1,3.274,1.07,3.274,2.755a2.757,2.757,0,0,1-2.691,2.691v.065c1.913.13,3.371,1.2,3.371,2.853,0,1.783-1.621,2.95-3.76,2.95h-9.142V64.876h8.655a5.9,5.9,0,0,0,5.9-5.9V29.509Z" transform="translate(-218.582 -29.509)" fill="url(#jcbLinearGradient2)" />
              <path id="path6360" d="M239.579,108.35a1.379,1.379,0,0,0-1.2-1.394c-.065,0-.227-.032-.324-.032h-3.08v2.853h3.08a.9.9,0,0,0,.324-.032A1.379,1.379,0,0,0,239.579,108.35Z" transform="translate(-232.059 -93.146)" fill="url(#jcbLinearGradient3)" />
            </g>
            <path d="M41.27,29.509a5.9,5.9,0,0,0-5.9,5.9V49.964a11.667,11.667,0,0,0,5.09,1.329A2.823,2.823,0,0,0,43.6,48.375V41.5h5.057v6.84c0,2.658-1.653,4.83-7.261,4.83a24.886,24.886,0,0,1-6.062-.746V64.843h8.655a5.9,5.9,0,0,0,5.9-5.9V29.509Z" transform="translate(-32.42 -26.753)" fill="url(#jcbLinearGradient4)" />
            <path d="M133.042,29.509a5.9,5.9,0,0,0-5.9,5.9v7.715c1.491-1.264,4.085-2.075,8.266-1.88a26.306,26.306,0,0,1,4.636.713v2.5a11.222,11.222,0,0,0-4.474-1.3c-3.177-.227-5.09,1.329-5.09,4.052,0,2.755,1.913,4.312,5.09,4.052a11.774,11.774,0,0,0,4.474-1.3v2.5a25.679,25.679,0,0,1-4.636.713c-4.182.194-6.775-.616-8.266-1.88V64.908H135.8a5.9,5.9,0,0,0,5.9-5.9v-29.5Z" transform="translate(-107.886 -26.753)" fill="url(#jcbLinearGradient5)" />
          </g>
        </g>
      </g>
    </svg>
  );
};

Jcb.defaultProps = {
  size: 100,
  className: "",
  id: ""
};

Jcb.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
